import { render } from "./md2024-3.vue?vue&type=template&id=5012f327"
import script from "./md2024-3.vue?vue&type=script&lang=js"
export * from "./md2024-3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__